module.exports = __webpack_public_path__ + "media/images/gift/gift-menu-d9776b797eba32b1a6a5701be2f342a4.png";